var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5799_14865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00098 4.66683C6.00905 3.21681 6.07335 2.43154 6.5856 1.91928C7.17139 1.3335 8.1142 1.3335 9.99982 1.3335L10.6665 1.3335C12.5521 1.3335 13.4949 1.3335 14.0807 1.91928C14.6665 2.50507 14.6665 3.44788 14.6665 5.3335L14.6665 10.6668C14.6665 12.5524 14.6665 13.4953 14.0807 14.081C13.4949 14.6668 12.5521 14.6668 10.6665 14.6668L9.99982 14.6668C8.1142 14.6668 7.17139 14.6668 6.5856 14.081C6.07335 13.5688 6.00905 12.7835 6.00098 11.3335",
    stroke: "#FCFCFC",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8L1.33333 8M1.33333 8L3.66667 6M1.33333 8L3.66667 10",
    stroke: "#FCFCFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5799_14865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.68e82e943ede1f73f838ebaa5342116a.svg";
export { ForwardRef as ReactComponent };